import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SessionService } from '../Util/Session/session.service';
import { CommonService } from '../Model/Common/common.service';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomDateParserFormatter } from '../Util/DateFormat/date-format.service';
import { TooltipService } from '../Util/Tooltip/tooltip.service';
import { SeparationModuleService } from '../separation-module.service';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { EmployeeRegistrationService } from '../Model/EmployeeRegistration/employee-registration.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ConfirmationComponent } from '../Component/Confirmation/confirmation/confirmation.component';

@Component({
  selector: 'app-employee-resign',
  standalone: true,
  imports: [FormsModule, CommonModule, NgSelectModule, NgbDatepickerModule, LoaderComponent, RouterModule],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './employee-resign.component.html',
  styleUrl: './employee-resign.component.scss'
})
export class EmployeeResignComponent {

  isDisabled: boolean = false;
  user: any;
  ReasonLoad: any[] = [];
  Trackings = [];
  isApprovalLavel = true;
  TrackingsUser = [];

  Filter = {
    Remark: null,
    isShowError: false,
  }

  DetailData = {
    WebESSApprovalRequestTrackingId: null as any,
    TransactionId: null as any,
    EmpMasterId: null,
    EmpCode: null,
    Photo: null as any,
    EmployeeName: null as any,
    BranchName: null,
    ClientLocation: null,
    DesignationMasterId: null,
    DesignationName: null,
    ShiftMasterId: null,
    ShiftTitle: null,
    EmpType: null as any,
    ApprovalStatus: null as any,
  };

  constructor(
    private session: SessionService,
    public common: CommonService,
    protected tooltip: TooltipService,
    private separation: SeparationModuleService,
    private toast: ToastService,
    private employeeRegistration: EmployeeRegistrationService,
    private dateFormat: CustomDateParserFormatter,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private dateFormate: CustomDateParserFormatter,
  ) {
    this.user = session.GetUserDetails();
    this.route.params.subscribe(params => this.employee.employeeSeparationRequestId = parseInt(params['id']));
  }

  ngOnInit() {
    this.employee.empCode = this.user.EmpCode;
    this.employee.empName = this.user.UserName;
    this.employee.requestedDate = new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', });
    this.ESS_AdditionalFillCombo();
    if(this.employee.employeeSeparationRequestId > 0) {
      this.GetEmployeeRequestDetail(1);
    }else{
      this.GetEmployeeRequestDetail(5);
    }
  }

  employee = {
    empCode: '',
    empName: '',
    designation: '',
    requestedDate: '',
    noticePeriod: '',
    lastWorkingDay: '',
    reportingManager: '',
    photo: '',
    employeeSeparationRequestId: 0,
    approvalStatus: '',
    reportingManagerId: null as any,
  };

  form = {
    proposedLastWorkingDay: null as any,
    reason: null,
    remark: ''
  };

  SaveRequest(selecttype: any = '') {
    this.isDisabled = true;
    this.separation.EmpSeparationRequestSave({
      SelectType: selecttype,
      ESS_EmpSeparationRequestId: this.employee.employeeSeparationRequestId,
      EmpMasterID: this.user.UserId,
      ESS_SeparationReasonId: this.form.reason,
      RequestedLastWorkingDate: this.form.proposedLastWorkingDay ? this.dateFormat.format(this.form.proposedLastWorkingDay) : null,
      EmployeeRemark: this.form.remark,
      ReportingManagerId1: this.employee.reportingManagerId,
      NoticePeriod: selecttype == 'WITHDRAWN' ? this.employee.noticePeriod : this.employee.noticePeriod.split(' ')[0],
      By: this.user.UserId,
    }).subscribe({
      next: (response) => {
        if (response.ErrorCode == "909" || response.ErrorCode == "910") {
          this.toast.show({ message: response.ErrorMessage, type: toastTypeEnum.success });
          this.router.navigate(['/resign']);
        } else {
          this.toast.show({ message: response.ErrorMessage, type: toastTypeEnum.warning });
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (err) => {
        this.isDisabled = false;
      },
    })
  }

  onSubmit(form: any) {
    if (form.valid) {
      this.Resign();
    } else {
      form.submitted = true;
    }
  }

  removeError() {
    this.Filter.isShowError = false;
  }

  GetEmployeeRequestDetail(selecttype: any) {
    this.isDisabled = true;
    this.separation.EmpSeparationRequestLoad({
      SelectType: selecttype,
      EmpMasterID: this.user.UserId,
      EmpType: this.user.EmpType,
      EmpCode: this.user.EmpCode,
      ESS_EmpSeparationRequestId: this.employee.employeeSeparationRequestId,
    }).subscribe({
      next: (response) => {
        if (selecttype == 5) {
          const data = response.Table[0];
          this.employee.noticePeriod = data?.NoticePeriod + ' Days';
          this.employee.lastWorkingDay = this.convertDate(data?.LastWorkingDay);
          this.employee.reportingManager = data?.ReportingManager1;
          this.employee.reportingManagerId = data?.ReportingManagerId1;
          this.employee.designation = data?.DesignationName;
        } else if (selecttype == 1) {
          const data = response.Table[0];
          this.employee.requestedDate = data.DateOfResignation;
          this.employee.designation = data.DesignationName;
          this.form.remark = data.EmployeeRemark;
          this.form.reason = data.ESS_SeparationReasonId;
          // this.form.proposedLastWorkingDay = data.RequestedLastWorkingDate;
          this.employee.lastWorkingDay = data.CalculatedLastWorkingDate;
          this.employee.approvalStatus = data.ApprovalStatus; 
          // const proposedLastWorkingDay = new Date(data.RequestedLastWorkingDate);
          // this.form.proposedLastWorkingDay = this.dateFormate.parse(proposedLastWorkingDay.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', }));
          this.employee.reportingManager = data.ReportingManager1;
          this.employee.reportingManagerId = data.ReportingManagerId1;
          this.employee.noticePeriod = data.NoticePeriod; 
        }
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (err) => {
        this.isDisabled = false;
      },
    })
  }

  convertDate(input: any) {
    if (input !== '' || input !== null) {
      return new Date(input).toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      });
    }
    return '';
  }

  ESS_AdditionalFillCombo() {
    this.isDisabled = true;
    this.employeeRegistration.ESS_AdditionalFillCombo({
      'SelectType': 'SeparationReason',
      'UserId': this.user.UserId
    }).subscribe({
      next: (response) => {
        this.ReasonLoad = response.Table;
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async Resign() {
      const modalRef = this.modalService.open(ConfirmationComponent, {
        size: 'md',
        backdrop: 'static',
        windowClass: 'confirmation-modal'
      });
  
      modalRef.componentInstance.Message = 'Are you sure want to save?'
  
      modalRef.result.then((result: any) => {
        if (result) {
          this.SaveRequest();
        }
      }).catch(() => { });
    }
}
